import type { CompetitionRow, CompetitionsList } from '@/api/competitions'

import type { FoldedList } from '../list/paging'

/* The competitions list's loaded pages as one list, and the category choices. */

export type CompetitionsResult = FoldedList<CompetitionRow, CompetitionsList>

/**
 * The category filter's choices: the scope's categories, any on the rows shown (should
 * the scope's read fail), and the one a link names, in alphabetical order.
 */
export function categoryOptions(
  scope: readonly string[] | undefined,
  rows: readonly CompetitionRow[],
  selected: string | undefined,
): string[] {
  const shown = rows.map((row) => row.category).filter((category): category is string => Boolean(category))
  return [...new Set([...(scope ?? []), ...shown, ...(selected ? [selected] : [])])].sort((a, b) => a.localeCompare(b))
}
